import { useEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Skeleton } from '@mui/material';
import { Stack } from '@mui/material';

am4core.useTheme(am4themes_animated);

const StackBarChart = ({ data }) => {
  const [divHeight, setDivHeight] = useState(500);
  const [showLoader, setShowLoader] = useState(false);
  const [height, setHeight] = useState();

  useEffect(() => {
    setShowLoader(true);

    if (data.length) {
      const updatedChart = am4core.create('stackBarChartdiv', am4charts.XYChart);
      
      setHeight(`${Object.keys(data[0]).length * 20}px`);

      updatedChart.events.on('ready', () => {
        setShowLoader(false);
      });

      updatedChart.data = data;
      updatedChart.paddingRight = 20;

      /* Create legend */
      updatedChart.legend = new am4charts.Legend();
      /* Create a separate container to put legend in */
      let legendContainer = am4core.create('legenddiv2', am4core.Container);
      legendContainer.width = am4core.percent(100);
      legendContainer.height = am4core.percent(100);

      updatedChart.legend.parent = legendContainer;
      updatedChart.legend.labels.template.maxWidth = 100;
      updatedChart.legend.labels.template.truncate = true;

      updatedChart.legend.labels.template.adapter.add('maxWidth', () => {
        return 300;
      });

      let categoryAxis = updatedChart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.dataFields.category = 'category';

      let valueAxis = updatedChart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.tooltip.disabled = true;
      valueAxis.renderer.minWidth = 35;
      // valueAxis.numberFormatter = new am4core.NumberFormatter();
      // valueAxis.numberFormatter.numberFormat = '#a';

      valueAxis.formatLabel = function (value) {
        let locale = window.localStorage.getItem('locale') ? window.localStorage.getItem('locale') : 'sq';

        let billionShortForm = locale === 'en' ? ' B ALL' : ' MLD ALL',
            millionShortForm = locale === 'en' ? ' M ALL' : ' MLN ALL',
            thousandShortForm = locale === 'en' ? ' K ALL' : ' MIJE ALL';

        if(value >= 1000000000) {
          return (value/1000000000).toString()+billionShortForm;
        } else if(value >= 1000000) {
          return (value/1000000).toString()+millionShortForm;
        } else if(value >= 1000) {
          return (value/1000).toString()+thousandShortForm;
        } else {
          return (value)+' ALL';
        }
      }

      const firstElement = data[0];
      const availableProperties = Object.keys(firstElement);

      setDivHeight(
        availableProperties.length > 1
          ? availableProperties.length > 4
            ? availableProperties.length > 6
              ? availableProperties.length > 8
                ? 700
                : 650
              : 600
            : 550
          : 500,
      );

      availableProperties.forEach((el) => {
        if (el !== 'category') {
          let series = updatedChart.series.push(new am4charts.ColumnSeries());
          series.dataFields.categoryX = 'category';
          series.dataFields.valueY = el;
          series.stacked = 'true';
          series.tooltipText = `${el}: {valueY.value}`;
          series.name = el;

          let labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.locationY = 0.5;
          labelBullet.label.fill = am4core.color('#fff');
        }
      });

      updatedChart.cursor = new am4charts.XYCursor();

      let scrollbarX = new am4charts.XYChartScrollbar();
      updatedChart.scrollbarX = scrollbarX;
      updatedChart.exporting.menu = new am4core.ExportMenu();
      updatedChart.exporting.menu.align = 'left';
      updatedChart.exporting.menu.verticalAlign = 'top';
    }
  }, [data]);

  return (
    <>
      <>
        <div id='stackBarChartdiv' style={{ width: showLoader ? '0' : '100%', height: showLoader ? '0' : divHeight }}></div>
        <div
          id='legendwrapper'
          style={{
            width: showLoader ? '0' : '100%',
            height: showLoader ? '0' : height,
            maxHeight: '250px',
            border: '1px dotted #c99',
            margin: '1em 0',
            overflowX: 'none',
            overflowY: 'auto',
          }}
        >
          <div id='legenddiv2' style={{ height: showLoader ? '0' : height }}></div>
        </div>
      </>
      {showLoader && (
        <Stack spacing={1}>
          <Skeleton variant='text' sx={{ fontSize: '1rem' }} />
          <Skeleton variant='rounded' width={'auto'} height={500} />
        </Stack>
      )}
    </>
  );
};

export default StackBarChart;
